import React, { Component } from 'react'

export default class PaymentsForm extends Component {
  render() {
    return (
      <div>PaymentsForm</div>
    )
  }
}
